import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss']
})
export class CalendarioComponent implements OnInit {

  arrayComponent: any;
  infoComponent: any;
  utils: any;
  codeHtml: string;
  codeJs: string;
  constructor() {
    this.utils = window.utils;
    
    this.arrayComponent = [
      {
        id: 'input_date',
        titulo: 'Componente',
        subtitulo: '',
        componentRender: `
        <form>
            <div class="form-group">	
                <label for="date_start">Fecha de Inicio *</label>
                <input class="calendar form-control-govco" autocomplete="off" id="date_start" name="date_start" required="true" placeholder="DD/MM/AAAA" aria-label="Incluir fecha en números en forma día / mes / año. Ejemplo 01/06/2020"/>
            </div>
        </form>
`,
        codejs: 
        `$('.calendar').datepicker({
          locale: 'es-es',
          format: 'dd/mm/yyyy', 
          uiLibrary: 'bootstrap4',
          keyboardNavigation: true,
          icons: {
            rightIcon: '<span aria-label="Abrir calendario"><i class="material-icons">date_range</i></span>'
          }
        `
      },
    ]

    this.codeHtml = `
    <script src="https://unpkg.com/gijgo@1.9.13/js/gijgo.min.js" type="text/javascript"></script>
    <link href="https://unpkg.com/gijgo@1.9.13/css/gijgo.min.css" rel="stylesheet" type="text/css" />`;

    this.codeJs = `
    $('.calendar').datepicker({
      locale: 'es-es',
      format: 'dd/mm/yyyy', 
      uiLibrary: 'bootstrap4',
      keyboardNavigation: true,
      icons: {
        rightIcon: '<span aria-label="Abrir calendario"><i class="material-icons">date_range</i></span>'
      }
    `;

    this.infoComponent = {
      titulo: "Calendario",
      subtitulo: ''
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.utils.calendar();
  }
}
